export default __webpack_public_path__ + "static/media/03-JYOTI MANANKALAGI.4d4c4f2b.jpg";